import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export type { SafetyPoliciesResponse, SafetyPolicy } from "@unbox/api";
export { SAFETY_POLICY_LABELS, SAFETY_POLICY_PRIORITY } from "@unbox/api";

const safetyPoliciesKey = (merchantId: string, workspaceId: string | null) => [
  "safety-policies",
  merchantId,
  workspaceId,
];

// The merchant's predefined safety policies (one per policy type), each linked
// to the sequence that runs when the policy is applied. A risk references one of
// these via `merchant_risks.safetyPolicyId`.
export const useSafetyPolicies = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: safetyPoliciesKey(scope.merchantId, scope.workspaceId),
    queryFn: async () => {
      if (!scope.merchantId) throw new Error("No merchant selected");

      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"]["safety-policies"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"]["safety-policies"].$get({
            param: scope.param,
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
  });
};
